export const BASE_URL =
  import.meta.env.VITE_BASE_URL || 'http://127.0.0.1:8000';
export const API_VERSION = import.meta.env.VITE_API_VERSION || 'v1';
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || `${BASE_URL}/${API_VERSION}`;
